export default "__VITE_ASSET__5438ec69__"